// Returns a negated version of the passed-in predicate.
export default function negate(predicate) {
  return function() {
    return !predicate.apply(this, arguments);
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/negate.js
// module id = 186
// module chunks = 8